function toggleColorItem(colorItems){
  colorItems.forEach(function(colorItem){

    // For each color Item, create click event to open it
    colorItem.querySelector('button[data-coloritem-btn]').addEventListener("click", function(event){

      // If popin is closed
      if(colorItem.querySelector('button[data-coloritem-btn]').getAttribute('aria-expanded') === "false"){
        
        //add listener on color item popin close button to close it
        colorItem.querySelector('[data-coloritem] [data-coloritem-btn]').addEventListener("click", function(){
          closeColorItem(colorItem);
        }, false);
        
        // Closes all the other color items if open before opening a new one
        closeAllColorItems(colorItems);

        // Opens popin
        openColorItem(colorItem);
        event.stopPropagation();

      } else {
        closeColorItem(colorItem);
      }
    }, true);
  });

  wholeBodyListener();
};

// Opens the color item popin and sets listeners to close it
function openColorItem(colorItem){
  if(colorItem.querySelector('button[data-coloritem-btn]').getAttribute('aria-expanded') === "false"){
    colorItem.querySelector('button[data-coloritem-btn]').setAttribute('aria-expanded','true');
    colorItem.querySelector('[data-coloritem]').setAttribute('aria-hidden', 'false');
  }
};

// Closes the color item popin
function closeColorItem(colorItem){
  if(colorItem.querySelector('button[data-coloritem-btn]').getAttribute('aria-expanded') === "true"){
    colorItem.querySelector('button[data-coloritem-btn]').setAttribute('aria-expanded','false');
    colorItem.querySelector('[data-coloritem]').setAttribute('aria-hidden', 'true');
  }
};

// Closes all the color items popin if open
function closeAllColorItems(){
  var colorItems = document.querySelectorAll('.js-color-item')
  colorItems.forEach(function(colorItem){
    closeColorItem(colorItem);
  })
};

function isDescendant(parent, child) {
  var node = child.parentNode;
  while (node != null) {
    if (node == parent) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
}

function wholeBodyListener(){
  document.body.addEventListener('click', function(event) {
    
    // Defines target and ignored elements so we can compare them later
    var ignoredElements = document.querySelectorAll('.js-color-item');
    var target = event.target;

    // Defines isMatch so we can close the loops earlier
    var isMatch = false

    // Compares event target and ignored element
    ignoredElements.forEach(function(ignore){
      if (isDescendant(ignore, target)) {
        isMatch = true;
      }
    });

    // If no match on any comparison, close all color items.
    if (!isMatch) {
      closeAllColorItems();
    }
  });
}

// Hides elements that aren't needed (favorites)
function hideColorItemLinks(){
  var colorItemLinks = Array.from(document.querySelectorAll('.ColorItem-links'))
  colorItemLinks.forEach(function(colorItemLink){
    colorItemLink.style.display = 'none'
  })
}

function initColorItem(){
  var COLORITEM_SEL = '.js-color-item';
  var colorItems = document.querySelectorAll(COLORITEM_SEL);

  if(colorItems.length === 0){
    return;
  };

  toggleColorItem(colorItems);
  hideColorItemLinks()
};


window.onload = function() {
  initColorItem();
};